import type { TFunction } from 'i18next';
import { DefaultScores } from '../../constants';
import type { PsychologicalResult } from '../../model';
import formatScoreOutOf from '../formatters';
import { burnoutInventoryHeight } from '.';
import type { AssessmentResultItemDataFragment } from '@/gql/graphql';

const parseBurnoutInventory = (t: TFunction, items: AssessmentResultItemDataFragment[]): PsychologicalResult | null => {
    const item = items.find(i => i.result.__typename === 'BurnoutInventoryResult');
    if (!item || item.result.__typename !== 'BurnoutInventoryResult') {
        return null;
    }

    const { moduleInstance } = item;
    const burnoutInventoryResult = item.result;

    if (!moduleInstance?.moduleDefinitionIdentifier) {
        return null;
    }

    const categories = burnoutInventoryResult?.categoryAverages || [];
    if (categories.length === 0) {
        return null;
    }

    const radarData = categories.map(c => ({
        axis: c.category,
        individual: Number(c.averageScore.toFixed(2)),
    }));
    const hasValidMax = categories.some(c => (c.maximumPossibleScore ?? 0) > 0);
    const maxDomain = hasValidMax
        ? Math.max(1, ...categories.map(c => c.maximumPossibleScore ?? 0))
        : DefaultScores.BurnoutInventoryMaxScore;

    return {
        moduleDefinitionIdentifier: moduleInstance.moduleDefinitionIdentifier,
        name: moduleInstance.name ?? '',
        description: moduleInstance.description ?? '',
        radarGroups: [
            {
                key: 'burnout-inventory',
                scoreCards: categories.map(c => ({
                    label: c.category,
                    value: formatScoreOutOf(t, c.averageScore, c.maximumPossibleScore, 2),
                    badge: c.label,
                    badgeColor: c.badgeColor,
                })),
                charts: [
                    {
                        data: radarData,
                        maxDomain,
                        height: burnoutInventoryHeight,
                        variant: 'bare',
                    },
                ],
            },
        ],
    };
};

export default parseBurnoutInventory;
